import { ApiNotFoundComponentModule } from './../../_component/api-not-found/api-not-found.component.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { HeaderModule } from "src/app/_component/header/header.module";
import { ItemCommunityModule } from "../item-community/item-community.module";
import { BreadcrumbComponentModule } from './../../_component/breadcrumb/breadcrumb.module';
import { DetailCommunityPageRoutingModule } from "./detail-community-routing.module";
import { DetailCommunityPage } from "./detail-community.page";
import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DetailCommunityPageRoutingModule,
    ItemCommunityModule,
    HeaderModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    LoadingStiModule,
    SharedDirectivesModule,
  ],
  declarations: [DetailCommunityPage],
})
export class DetailCommunityPageModule {}
